import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_theme_provider = _resolveComponent("v-theme-provider")!
  const _component_Toaster = _resolveComponent("Toaster")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_theme_provider, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, {
            transition: "scroll-x-transition",
            class: "body"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_Toaster, { position: "top-right" })
    ]),
    _: 1
  }))
}